// extracted by mini-css-extract-plugin
export default {"container":"mzpWMa","header":"qEHhGi","link":"vU5j4Q","title":"CxiuU0"};